<ng-container *ngIf="visible">
  <div class="ng-image-gallery-preview" [class.ng-image-gallery-preview-visible]="visible">
    <div class="image-gallery-preview" *ngIf="currentImage">
      <div class="image-preview-header d-flex justify-content-between">
        <div class="image-preview-header-left d-flex column">
          <ng-container *ngIf="!contextualInfo">
            <div class="profile-icon">
              <i class="material-symbols-outlined profile-icon image-text-info-white">account_circle</i>
            </div>
            <div>
              <div class="image-created-by image-text-info-white">{{ user?.filterText }}</div>
              <div class="image-created-date image-text-info-white date-text">{{ createdDate }}</div>
            </div>
          </ng-container>
        </div>
        <div class="image-preview-header-center image-text-title-white column">
          <ng-container *ngIf="currentImage.title">{{ currentImage.title }}</ng-container>
          <ng-container *ngIf="!currentImage.title">{{ currentImage.filename }}</ng-container>
        </div>
        <div class="image-preview-header-right column">
          <div class="actions-wrapper d-flex">
            <div *ngIf="!isExternalUser" class="action-download me-2" (click)="downloadAttachment()">
              <i class="material-symbols-outlined action-icon image-text-info-white">download</i>
            </div>
            <div *ngIf="!isExternalUser" class="action-delete" (click)="deleteAttachment()">
              <i class="material-symbols-outlined action-icon image-text-info-white">delete</i>
            </div>
            <div class="action-close" (click)="hide()">
              <i class="material-symbols-outlined action-icon image-text-info-white">close</i>
            </div>
          </div>
        </div>
      </div>

      <div class="image-gallery-wrapper">
        <div
          *ngIf="imageDocuments.length > 1"
          class="gallery-arrow prev"
          [class.disabled]="currentIndex === 0"
          (click)="previousImage()">
          <i class="material-symbols-outlined" style="margin-left: 6px">arrow_back_ios</i>
        </div>

        <div class="image-preview-wrapper">
          <div class="image-loading-spinner" *ngIf="isImageLoading">
            <div class="spinner-border text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <img
            class="image"
            [src]="currentImageUrl()"
            [class.loading]="isImageLoading"
            (load)="onImageLoad()"
            (error)="onImageError()" />
        </div>

        <div
          *ngIf="imageDocuments.length > 1"
          class="gallery-arrow next"
          [class.disabled]="currentIndex === imageDocuments.length - 1"
          (click)="nextImage()">
          <i class="material-symbols-outlined">arrow_forward_ios</i>
        </div>
      </div>

      <div *ngIf="imageDocuments.length > 1" class="image-counter">
        {{ currentIndex + 1 }} / {{ imageDocuments.length }}
      </div>

      <div *ngIf="imageDocuments.length > 1" class="thumbnail-navigation">
        <div
          class="thumbnail-scroll-button left"
          [class.visible]="canScrollThumbnailsLeft"
          (click)="scrollThumbnailsLeft()">
          <i class="material-symbols-outlined">chevron_left</i>
        </div>

        <div class="thumbnail-strip" #thumbnailStrip>
          <div
            *ngFor="let image of imageDocuments; let i = index"
            class="thumbnail"
            [class.active]="i === currentIndex"
            (click)="goToImage(i)">
            <img [src]="getImageUrl(image)" />
          </div>
        </div>

        <div
          class="thumbnail-scroll-button right"
          [class.visible]="canScrollThumbnailsRight"
          (click)="scrollThumbnailsRight()">
          <i class="material-symbols-outlined">chevron_right</i>
        </div>
      </div>

      <div *ngIf="getContextualInfoForDisplay()" class="contextual-info-section">
        <div class="contextual-info-card">
          <div class="user-info-section">
            <div class="user-avatar">
              <i class="material-symbols-outlined">account_circle</i>
            </div>
            <div class="user-details">
              <div class="user-name">{{ user?.filterText }}</div>
              <div class="timestamp">{{ createdDate }}</div>
            </div>
          </div>
          <div class="check-info">
            <div class="response-label">{{ T.control.check.one | translate }}</div>
            <div class="check-title">{{ getContextualInfoForDisplay()?.title }}</div>
          </div>
          <div class="check-response">
            <div class="response-label">{{ T.control.check_response | translate }}</div>
            <div class="response-comment">
              {{ getCheckResponseDisplay() | htmlString }}
            </div>
            <div class="check-text-response text-truncate" *ngIf="getContextualInfoForDisplay()?.textResponse">
              "{{ getContextualInfoForDisplay()?.textResponse | htmlString }}"
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
